import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const MiniShoppingBagContainer = styled("div")`
    color: ${({theme}) => `${theme.uxfabric.text.primary}`};
    display: flex;
    flex-direction: column;
    border-radius: 0.25rem;
    background-color: ${({theme}) => theme.uxfabric.components.dialog.dialogContent.default.backgroundColor};
`
export const PriceWrapperItem = styled("div")`
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    font-size: ${({theme}) => theme.uxfabric.global.body3.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.global.body3.fontWeight};
    color: ${({theme}) => `${theme.uxfabric.text.primary}`};
`

export const TotalText = styled("div")`
    font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    font-weight: ${({theme}) => `${theme.uxfabric.global.body3.fontWeight}`};
    font-size: ${({theme}) => `${theme.uxfabric.global.body3.fontSize}`};
    text-transform: ${({theme}) => `${theme.uxfabric.global.body3.textTransform}`};
    letter-spacing: ${({theme}) => `${theme.uxfabric.global.body3.letterSpacing}`};
`

export const TotalValue = styled("p")`
    font-size: ${({theme}) => `${theme.uxfabric.global.body3.fontSize}`};
    font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    font-weight: ${({theme}) => `${theme.uxfabric.global.body3.fontWeight}`};
    text-transform: ${({theme}) => `${theme.uxfabric.global.body3.textTransform}`};
    letter-spacing: ${({theme}) => `${theme.uxfabric.global.body3.letterSpacing}`};
    margin: 0;
`

export const PromotionWrapper = styled("div")`
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 1rem 0 1rem;
    color: ${({theme}) => theme.uxfabric.brand.success};
    font-size: 0.875rem;
`

export const PromotionDiscount = styled("div")`
    font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
`

export const StandardDeliveryContainer = styled("div")`
    font-size: ${({theme}) => theme.uxfabric.global.body2.fontSize};
    font-family: ${({theme}) => theme.uxfabric.global.body2.fontFamily};
    color: ${({theme}) => theme.uxfabric.text.primary};
`
export const StandardDeliveryText = styled("p")`
    font-size: ${({theme}) => theme.uxfabric.global.body2.fontSize};
    font-family: ${({theme}) => theme.uxfabric.global.body2.fontFamily};
    padding: 0 1rem 0 1.125rem;
    color: ${({theme}) => theme.uxfabric.text.primary};
    font-weight: ${({theme}) => theme.uxfabric.global.body2.fontWeight};
    margin: 0;
`

export const Block = styled("span")`
    display: block;
`

export const StyledContainer = styled("div")`
    background: ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.backgroundColor};
    border: 1px solid ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.borderColor};
    border-bottom: unset;
`
